<template>
  <div class="jumbotron no_space dmbs-container">
    <h1>{{ $t('Recintos') }} {{ provincia }}</h1>

    <!-- <pre v-if="recintosWeb">
        {{ recintosWeb.length}}
      </pre>     -->
    <lista-recintos :listadoRecintos="recintosWeb" v-if="recintosWeb"></lista-recintos>
    <!-- <div
      id="fuera"
      class="container fluid mt-0"
      style="height: 100%; display: block;"
    >
      <iframe
        :src="iframeSrc"
        style="min-width: 100%; border: none;"
        frameborder="no"
        width="100%"
        scrolling="no"
        id="iFrameResizer0"
        @load="resizeIframe"
      >Su navegador no soporta IFRAMES. Inténtelo con otro distinto.</iframe>
    </div> -->
  </div>
</template>
<style>
iframe {
  width: 1px;
  min-width: 100%;
}
</style>
<script>
import { globales } from '../components/comunes'
import iFrameResize from '../assets/iframeResizer'
// recintos
import FireStoreParser from 'firestore-parser'
import axios from 'axios'

import listaRecintos from '../components/seccion/listaRecintos2'

export default {
  mixins: [globales],
  components: {
    listaRecintos,
  },
  created() {
    this.$store.commit('setCargando', true)

    this.scrollTop()
    // if (this.$store.state.recintosWeb) {
    //   this.$store.commit("setCargando", false);
    //   console.log('mira', this.$store.state.recintosWeb)
    //   return
    // }

    this.scrollTop()
    const url =
      'https://firestore.googleapis.com/v1beta1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/kutxabank.cms/recintos?orderBy=Nombre&pageSize=200'
    axios
      .get(url)
      .then((res) => FireStoreParser(res.data))
      .then((json) => {
        this.$store.commit('setCargando', false)
        // this.recintosWeb = json.documents
        console.log('axios', json)
        const webData = json
        this.$store.commit('setRecintosWeb', json.documents)
      })
  },
  data() {
    return {
      miRecinto: '',
    }
  },
  computed: {
    recintosWeb() {
      return this.$store.state.recintosWeb
    },
    provincia() {
      return this.$route.params.id
    },
    iframeSrc() {
      const urlBase =
        'https://ticket.kutxabank.es/j4pro/public/janto/main.php?Nivel=menuRecintos'
      const pagina = this.$route.params.id
      const filtro = this.recintos.find((e) => e.id == pagina)
      const idProvincia = '&idProvincia=' + filtro.elemento
      const Idioma = '&Idioma=' + this.$i18n.locale.toUpperCase()

      this.miRecinto = filtro.nombre

      return urlBase + idProvincia + Idioma
    },
  },
  methods: {
    resizeIframe(event) {
      const iframeActual = document.getElementById('fuera')
      // $('iframe').iFrameResize( [{log: true}] );
      var iframes = iFrameResize(
        {
          log: false, // Enable console logging
          heightCalculationMethod: 'lowestElement',
        },
        '#' + event.target.id
      )
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>
